import * as FIELD_NAME from 'constant/form-item-names'
import * as FIELD_LABEL from 'constant/form-labels'
import * as RULES from 'constant/form-rules'
import { Form, Input, Select } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

const { Option } = Select

const getSelect = (sites) => (
  <Select
    bordered={false}
    placeholder={'Site'}
    showSearch={false}
    size='large'
    style={{ background: '#fff' }}
  >
    {sites.map(({ site_name: name, uuid }) => (
      <Option
        key={uuid}
        value={uuid}
      >
        {_.startCase(name)}
      </Option>
    ))}
  </Select>
)
const SiteSelect = ({ sites, disabled = false }) => {
  return (disabled
    ? <>
      <span>{FIELD_LABEL.SITE_SELECT}</span>
      <Form.Item
        name={FIELD_NAME.SITES}
      >
        <Input
          defaultValue={sites.site_name}
          disabled={disabled}
          placeholder={'site'}
          value={sites.site_uuid}
        />
      </Form.Item>
    </>
    : <> <span>{FIELD_LABEL.SITE_SELECT}</span>
      <Form.Item
        name={FIELD_NAME.SITES}
        rules={[RULES.REQUIRED]}
      >
        {getSelect(sites)}
      </Form.Item></>
  )
}

SiteSelect.propTypes = {
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  sites: PropTypes.array
}

export default SiteSelect
